import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router';
import { selectedDateWithoutTime } from '@store/global/selectors';
import { selectValidParams, selectDate, selectGridData } from '@pages/reporting-pages/shipment-stops/store/selectors';
import { ShipmentStopsParams } from '@api/order-reporting/types/ShipmentStopsParams';
import { setSearchParameters, setDate } from '@pages/reporting-pages/shipment-stops/store/slice';
import { useResetShipmentStopsMutation } from '@api/order-reporting/api';
import { AppPage } from 'components/app-page/AppPage';
import ParamsToolbar from '@pages/reporting-pages/shipment-stops/params-toolbar/ParamsToolbar';
import StatisticArea from '@pages/reporting-pages/shipment-stops/params-toolbar/StatisticArea';
import Grid from '@pages/reporting-pages/shipment-stops/grid-data/Grid';
import { headersObject } from '@pages/reporting-pages/shipment-stops/headersObject';



const ShipmentStops = () => {
	
	const validParams = useSelector(selectValidParams);
	const dateWithoutTime = useSelector(selectedDateWithoutTime);
	const date = useSelector(selectDate);
	const gridData = useSelector(selectGridData);

	const [ search, setSearch ] = useSearchParams();
	const dispatch = useDispatch();
	const updateSearchParameters = (parameters: ShipmentStopsParams) => dispatch(setSearchParameters(parameters));
	const updateDate = (value: string) => dispatch(setDate(value));

	const [ resetShipmentStops ] = useResetShipmentStopsMutation();


	useEffect(() => {
		if (!date) {
			updateDate(dateWithoutTime);
		}
	}, []);

	
	useEffect(() => {
		if (validParams) {
			setSearch({ ...validParams }, { replace: true });
		}
	}, [ validParams ]);

	
	useEffect(() => {
		if (search) {
			let paramDate = search.get('day');
			let paramCustomerId = search.get('customerId');
			let paramTileId = search.get('tileId');

			if (!paramDate) return;

			let newSearchParams: ShipmentStopsParams = {
				day: paramDate,
				...(paramCustomerId && { customerId: paramCustomerId }),
				...(paramTileId && { tileId: paramTileId }),
			}
			updateSearchParameters(newSearchParams);
		}
	}, [ search ]);


	const resetAllApi = useCallback(() => {
		resetShipmentStops();
	},[]);


	return (
		<AppPage
			className='reporting-page shipment-stops'
			pageLabel='Report - MCHD'
			resetPageApi={resetAllApi}
			csvData={{
				headers: headersObject,
				data: gridData,
				filename: 'reporting-mchd'
			}}
		>
			<ParamsToolbar />
			<StatisticArea />
			<Grid />
		</AppPage>
	)
};

export default ShipmentStops;